/*
 * Utility function to check if Kubernetes Enhanced plugin should be shown
 */

import { Entity } from '@backstage/catalog-model';
import { KUBERNETES_ANNOTATIONS } from '../types';

/**
 * 检查 Entity 是否有 Kubernetes 配置
 */
export function isKubernetesEnhancedAvailable(entity: Entity): boolean {
  const annotations = entity.metadata?.annotations || {};
  
  // 必须有集群名称
  const hasClusterName = !!annotations[KUBERNETES_ANNOTATIONS.CLUSTER_NAME];
  
  // 可选：有 kubernetes-id 或 label-selector
  const hasKubernetesId = !!annotations[KUBERNETES_ANNOTATIONS.ID];
  const hasLabelSelector = !!annotations[KUBERNETES_ANNOTATIONS.LABEL_SELECTOR];
  
  return hasClusterName && (hasKubernetesId || hasLabelSelector || true);
}

